export default {
  auth: {
    logged_in: "Welcome, ",
    logout: "Logout",
    logged_out: "Logout Success!",
    invalid: "Invalid credentials. Please login again."
  }
};
